import React, { useState } from 'react';
import ImageCarousel from '../ImageCarousel/ImageCarousel';
import ImageModal from '../ImageModal/ImageModal';

interface Props {
  urls: string[];
  withControls?: boolean;
  withFullWidth?: boolean;
}

const ImageGallery = ({ urls, withControls, withFullWidth }: Props) => {
  const [isOpenImageModal, setIsOpenImageModal] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const handleCloseImageModal = () => {
    setIsOpenImageModal(false);
    setImageIndex(0);
  };

  const handleOpenImageModal = (index: number) => {
    setImageIndex(index);
    setIsOpenImageModal(true);
  };

  return (
    <>
      <ImageCarousel urls={urls} onClick={handleOpenImageModal} withControls={withControls} withFullWidth={withFullWidth} />
      <ImageModal isOpen={isOpenImageModal} index={imageIndex} handleClose={handleCloseImageModal} urls={urls} />
    </>
  );
};

export default ImageGallery;
